/**
 * Basic Registration actions
 */
import Constants from '../../constants';

const { Auth } = Constants;

/**
 * Action object dispatched to sign up
 *
 * @param {object} formData sign up form data object
 */
const signup = (formData) => ({
  type: Auth.SIGNUP,
  formData,
});

/**
 * Action object dispatched when unable to sign up
 *
 * @param {object} error error object
 */
const signupError = (error) => ({
  type: Auth.SIGNUP_ERROR,
  error,
});

/**
 * Action object dispatched when sign up is successful
 *
 * @param {object} action:
 * {
 *   @property {object} user: object containing user data
 *   @property {object} authToken: authentication token
 * }
 */
const signupSuccess = ({ authToken: token, user }) => ({
  type: Auth.SIGNUP_SUCCESS,
  token,
  user,
});

/**
 * Action object dispatched to get access token
 *
 * @param {object} token auth token object
 */
const verifyInviteToken = (token) => ({
  type: Auth.VERIFY_INVITE_TOKEN,
  token,
});

/**
 * Action object dispatched when unable to get access token
 *
 * @param {object} error error object
 */
const verifyInviteTokenError = (error) => ({
  type: Auth.VERIFY_INVITE_TOKEN_ERROR,
  error,
});

/**
 * Action object dispatched when access token is fetched successfully
 *
 * @param {object} action:
 * {
 *  @property {string} token: authentication token
 *  @property {string} accessToken: access token
 * }
 */
const verifyInviteTokenSuccess = ({ token, retrievedToken, influencer }) => ({
  type: Auth.VERIFY_INVITE_TOKEN_SUCCESS,
  token,
  retrievedToken,
  influencer,
});

export default {
  verifyInviteToken,
  verifyInviteTokenError,
  verifyInviteTokenSuccess,
  signup,
  signupSuccess,
  signupError,
};
